/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * Transfer Transactions
 * PO Transactions

PO Transactions Viewer

API for printing labels using ZPL
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type { Error, Response, TransferCore } from '../model';
import { customInstanceNoFadcode } from '../mutator/customInstanceNoFadcode';
import type { ErrorType } from '../mutator/customInstanceNoFadcode';

/**
 * @summary This endpoint is used to create transfer transaction
 */
export const postTransferTransaction = (transferCore: TransferCore) => {
  return customInstanceNoFadcode<Response>({
    url: `/transfer/v1/transaction`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: transferCore,
  });
};

export const getPostTransferTransactionMutationOptions = <
  TError = ErrorType<Error | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferTransaction>>,
    TError,
    { data: TransferCore },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTransferTransaction>>,
  TError,
  { data: TransferCore },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTransferTransaction>>,
    { data: TransferCore }
  > = (props) => {
    const { data } = props ?? {};

    return postTransferTransaction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTransferTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTransferTransaction>>
>;
export type PostTransferTransactionMutationBody = TransferCore;
export type PostTransferTransactionMutationError = ErrorType<Error | void>;

/**
 * @summary This endpoint is used to create transfer transaction
 */
export const usePostTransferTransaction = <
  TError = ErrorType<Error | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferTransaction>>,
    TError,
    { data: TransferCore },
    TContext
  >;
}) => {
  const mutationOptions = getPostTransferTransactionMutationOptions(options);

  return useMutation(mutationOptions);
};
